<div class="modal wrapper" id="topUpModal"
    [style.display]="isVisible ? 'flex' : 'none'">
    <div class="modal-block top-up">
        <div class="title">
            <h2>
                Top-up your account
                <!-- <?php echo languageDetector('قم بشحن حسابك', 'Top-up your account'); ?> -->
            </h2>
            <button class="btn close" (click)="closePopup()">
                <img src="./images/delivery-wallet/x-close.svg" loading="lazy" alt="close">
            </button>
        </div>
        <form class="modal-inner" #amountForm="ngForm"
            (ngSubmit)="onSubmit(amountForm)">
            <div class="col amount">
                <div class="select-value">
                    <label for="amount">
                        Select amount
                        <!-- <?php echo languageDetector('حدد المبلغ', 'Select amount'); ?> -->
                    </label>
                    <div class="row">
                        <div
                            *ngFor="let amount of amounts"
                            class="select-item"
                            [ngClass]="{ 'active': amount === activeAmount }"
                            (click)="setActive(amount)">
                            {{ amount }}
                        </div>
                    </div>
                </div>
                <div class="value custom">
                    <label for="selectCustom">
                        Custom
                        <!-- <?php echo languageDetector('تخصيص', 'Custom'); ?> -->
                    </label>
                    <div class="inpt-wrapper currency">
                        <input type="number" id="selectCustom"
                            name="selectCustom"
                            [(ngModel)]="customAmount" #selectCustom="ngModel">
                    </div>
                    <span>
                        Minimum amount: <img  style="width: 15px;" loading="lazy" src='/images/icons/sar_symbol_black.svg'> {{ walletStatus == 'new' ? 100 : 25 }}
                        <!-- <?php echo languageDetector('الحد الأدنى للمبلغ: 25 ريال سعودي', 'Minimum amount: 25 SAR'); ?> -->
                    </span>
                </div>
            </div>

            <div class="col payment">
                <div class="select" *ngIf="savedCards?.length">
                    <label for="payment">Select payment method</label>
                    <div class="row cards">
                        <div class="item" *ngFor="let card of savedCards; let i = index" [ngClass]="{ 'active-card': activeCard === i }" (click)="setCardActive(i)">
                            <!-- <img src="./images/icons/delivery-wallet/VISA_logo.svg" alt="payment"> -->
                            <img *ngIf="card?.card_brand" loading="lazy" src="./images/delivery-wallet/{{card.card_brand}}_logo.svg" alt="card?.card_brand">
                            <!-- <span>{{ card.card_band }}</span> -->
                            <span>{{ card.card }}</span>
                        </div>
                    </div>
                </div>
                <div class="card-info">
                    <div class="card-checkbox">
                        <label for="card" (click)="toggleCheckbox()">
                            <div class="custom-checkbox">
                                <input
                                    name="save"
                                    type="checkbox"
                                    class="select-item orders_inputAll"
                                    [checked]="isChecked"
                                    (change)="toggleCheckbox()"
                                    hidden>
                                <svg *ngIf="!isChecked" class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" style="display: block;">
                                    <rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"></rect>
                                </svg>
                                <svg *ngIf="isChecked" class="checked" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: block;">
                                    <rect x="1" y="1" width="22" height="22" rx="3" fill="#1AACD9" stroke="#1AACD9" stroke-width="2"></rect>
                                    <path d="M20 6L9 17L4 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg>
                            </div>
                            Save card for future payments
                            <div class="card-icons">
                                <img
                                    src="./images/delivery-wallet/VISA_logo.svg"
                                    alt="card" loading="lazy">
                                <img
                                    src="./images/delivery-wallet/Master_card.svg"
                                    alt="card" loading="lazy">
                                <img src="./images/delivery-wallet/Mada.svg"
                                    alt="card" loading="lazy">
                                <img
                                    src="./images/delivery-wallet/Apple_Pay_logo.svg"
                                    alt="card" loading="lazy">
                            </div>
                        </label>
                    </div>
                </div>
            </div>
            <button class="btn md" type="submit">
                Continue
                <!-- <?php echo languageDetector('متابعة', 'Continue'); ?> -->
            </button>
        </form>
    </div>
</div>
